import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 8,
      padding: '8px 16px',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8,
    },
    imageWrapper: {
      width: 48,
      height: 48,
      borderRadius: 12,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[200],
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 12,
    },
  });

export default styles;
